// extracted by mini-css-extract-plugin
export var cardContainer = "_p3-0";
export var cardHeader = "_p3-2";
export var collapsedState = "_p3-3";
export var dragHandle = "_p3-5";
export var dragHandleIcon = "_p3-6";
export var dragging = "_p3-1";
export var titleArea = "_p3-4";